import logoSrc from "../../assets/logo.png";

// Official InsightPulse AI brand icon (transparent PNG). Rendered as-is —
// never recolored, cropped, or distorted — only scaled proportionally via
// the `size` prop. Use this everywhere the brand mark is needed instead of
// duplicating <img> tags throughout the app.
export default function Logo({ size = 32, className = "", alt = "InsightPulse AI" }) {
  return (
    <img
      src={logoSrc}
      alt={alt}
      width={size}
      height={size}
      draggable={false}
      className={`shrink-0 object-contain select-none ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
